module.exports = __webpack_public_path__ + "img/yelp.c3d86e7e.png";